import { render } from "./ModalVisibilidad.vue?vue&type=template&id=54dfe97a"
import script from "./ModalVisibilidad.vue?vue&type=script&lang=js"
export * from "./ModalVisibilidad.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__